import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 24
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-3xl md:text-5xl font-black text-brand tracking-tighter tabular-nums" data-id="element-111">
      <div className="flex flex-col items-center" data-id="element-112">
        <span data-id="element-113">{formatNumber(timeLeft.hours)}</span>
        <span className="text-xs text-slate-500 font-medium uppercase tracking-widest mt-1" data-id="element-114">
          hs
        </span>
      </div>
      <span className="text-slate-400 pb-5" data-id="element-115">:</span>
      <div className="flex flex-col items-center" data-id="element-116">
        <span data-id="element-117">{formatNumber(timeLeft.minutes)}</span>
        <span className="text-xs text-slate-500 font-medium uppercase tracking-widest mt-1" data-id="element-118">
          min
        </span>
      </div>
      <span className="text-slate-400 pb-5" data-id="element-119">:</span>
      <div className="flex flex-col items-center" data-id="element-120">
        <span data-id="element-121">{formatNumber(timeLeft.seconds)}</span>
        <span className="text-xs text-slate-500 font-medium uppercase tracking-widest mt-1" data-id="element-122">
          seg
        </span>
      </div>
    </div>;
}